import request from '@/utils/request'

export function adList(data) { //轮播图
  return request({
    url: 'api/index/adList',
    method: 'post',
    data,
  })
}

export function indexNew(data) { //首页新闻
  return request({
    url: 'api/index/indexNew',
    method: 'post',
    data,
  })
}

export function indexYwfw(data) { //首页-业务范围
  return request({
    url: 'api/index/indexYwfw',
    method: 'post',
    data,
  })
}

export function indexNews(data) { //首页-新闻资讯
  return request({
    url: 'api/index/indexNews',
    method: 'post',
    data,
  })
}

export function index(data) { //首页-基础信息
  return request({
    url: 'api/index/index',
    method: 'post',
    data,
  })
}

export function company(data) { //公司概况
  return request({
    url: 'api/index/company',
    method: 'post',
    data,
  })
}

export function ywfwList(data) { //业务范围
  return request({
    url: 'api/index/ywfwList',
    method: 'post',
    data,
  })
}

export function newsList(data) { //新闻资讯
  return request({
    url: 'api/index/newsList',
    method: 'post',
    data,
  })
}

export function newInfo(data) { //新闻详情
  return request({
    url: 'api/index/newInfo',
    method: 'post',
    data,
  })
}